export const SET_ORDERS = "SET_ORDERS";
export const RESET_ORDERS = "RESET_ORDERS";
export const SET_SPECIFIC_ORDER = "SET_SPECIFIC_ORDER";
export const RESET_SPECIFIC_ORDER = "RESET_SPECIFIC_ORDER";
